

































































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import EditCommand from "./editcommand.vue";
import CopyCommand from "./copycommand.vue";
import checkAuth from "@/lib/Common/checkauth";
import "@/assets/css/table.css";

class PageMeterRequest extends PageRequest {
  keyword: string;
  collectorId: string;
  meterId: string;
  commandType: number = 0;
}

@Component({
  components: { EditCommand, CopyCommand },
})
export default class commandlist extends AbpBase {

  //检测按钮权限
  checkButtonAuth(tag: string) {
    return checkAuth.CheckButton(tag);
  }
  edit() {
    this.editModalShow = true;
  }
  //复制
  async copy() {
    this.copyModalShow = true;
  }
  //filters
  pagerequest: PageMeterRequest = new PageMeterRequest();
  columnlist: any[] = [];
  collectorlist: any[] = [];
  collectorTree: any[] = [];
  searchName: string = ""; //树形搜索名称
  collectorTreeList: any[] = [];
  meterlist: any[] = [];
  editModalShow: boolean = false;
  copyModalShow: boolean = false;
  splitnum: number = 0.15;
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.collectorTree = this.collectorTreeList;
      return;
    }
    const rebuildData = (value, treeList) => {
      let newarr = [];
      treeList.forEach((element) => {
        if (element.children && element.children.length) {
          if (element.title != null && element.title.indexOf(value) > -1) {
            element.expand = true;
            newarr.push(element);
          }
          const ab = rebuildData(value, element.children);
          const obj = {
            ...element,
            expand: true,
            children: ab,
          };
          if (ab && ab.length) {
            newarr.push(obj);
          }
        } else {
          if (element.title != null &&element.title.indexOf(value) > -1) {
            newarr.push(element);
          }
        }
      });
      return newarr;
    };
    this.collectorTree = [];
    this.collectorTree = rebuildData(value, this.collectorTreeList);
  }
  changeSort(key) {
    if (key.order !== "normal") {
      this.pagerequest.sorting = key.key + " " + key.order;
    }
    this.getpage();
  }
  get list() {
    return this.$store.state.commandlist.list;
  }
  get loading() {
    return this.$store.state.commandlist.loading;
  }
  isActiveChange(val: number) {
    this.$store.commit("commandlist/setCurrentPage", 1);
    this.getpage();
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.collectorId = item[0].id == 0 ? null : item[0].id;
    }
    this.$store.commit("commandlist/setCurrentPage", 1);
    this.getpage();
  }
  pageChange(page: number) {
    this.$store.commit("commandlist/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("commandlist/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "commandlist/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.commandlist.pageSize;
  }
  get totalCount() {
    return this.$store.state.commandlist.totalCount;
  }
  get currentPage() {
    return this.$store.state.commandlist.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 60,
      align: "left",
      title: this.L("IndexNo"),
      fixed: "left",
    },
    {
      title: this.L("Organizations"),
      key: "organizationId",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.organizationId;
        let ite = JSON.parse(localStorage.getItem("organizations"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title:
                  info.length > 0 ? info[0].displayName : this.L("Nothing"),
              },
            },
            info.length > 0 ? info[0].displayName : this.L("Nothing")
          ),
        ]);
      },
    },
    {
      title: this.L("Areas"),
      key: "areaId",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.areaId;
        let ite = JSON.parse(localStorage.getItem("areas"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title: info.length > 0 ? info[0].fullName : this.L("Nothing"),
              },
            },
            info.length > 0 ? info[0].fullName : this.L("Nothing")
          ),
        ]);
      },
    },
    {
      sortable: true,
      title: this.L("MeterNo"),
      key: "meterNo",
      width: 150,
      fixed: "left",
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.meterNo },
            },
            params.row.meterNo
          ),
        ]);
      },
    },
    {
      sortable: true,
      title: this.L("RoomNo"),
      key: "roomNo",
      width: 130,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: { title: params.row.roomNo },
            },
            params.row.roomNo
          ),
        ]);
      },
    },
    {
      sortable: true,
      title: this.L("Collector"),
      key: "collectorId",
      width: 150,
      render: (h: any, params: any) => {
        let id = params.row.collectorId;
        let info = this.collectorlist.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].no : this.L("Unknown"));
      },
    },
    {
      sortable: true,
      title: this.L("Command") + this.L("Category"),
      key: "commandType",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.commandType;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      sortable: true,
      title: this.L("Command"),
      key: "commandStr",
      width: 400,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.commandStr,
            },
          },
          params.row.commandStr
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 180,
      fixed: "right",
      render: (h: any, params: any) => {
        let del = this.checkButtonAuth('commandListDel');
        let edit = this.checkButtonAuth('commandListEdit');
        let copy = this.checkButtonAuth('commandListCopy');
        return h("div", [
          copy ? h(
            "Button",
            {
              props: {
                type: "success",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("commandlist/edit", params.row);
                  this.copy();
                },
              },
            },
            this.L("Copy")
          ) : '',
          edit ? h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("commandlist/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ) : '',
          del ? h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "commandlist/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ) : '',
        ]);
      },
    },
  ];
  async getCollectorTree() {
    this.collectorTree = [];
    this.collectorTreeList = [];
    this.collectorTree.push({ id: "0", title: this.L("All"), expand: true });
    await this.$store
      .dispatch("collector/getalllist")
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.collectorTree.push({
              id: ele.id,
              title: ele.no,
              expand: true,
            });
            this.collectorlist.push(ele);
            this.collectorTreeList.push(ele);
          });
        }
      })
      .catch((err) => {
        //return null;
      });
  }
  //获取表列表
  async getMeterList() {
    await this.$store
      .dispatch("meter/getalllist")
      .then((val) => {
        if (val.length > 0) {
          val.forEach((ele) => {
            this.meterlist.push(ele);
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  async created() {
    await this.getCollectorTree();
    this.getMeterList();
    this.getItemDetail();
    this.getpage();
  }
  data() {
    return {
      paramslist: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
  getItemDetail() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    if (detaillist.length > 0) {
      let info = detaillist.filter((p) => {
        return p.itemId == 15;
      });
      info.forEach((ele) => {
        this.$data.paramslist.push({
          label: ele.name,
          value: ele.id,
        });
      });
    }
  }
}
